export default __webpack_public_path__ + "static/media/waiter.273a1fd5.mp3";